import { Box, Typography } from "@mui/material";
import React from "react";
import { MdAdd } from "react-icons/md";
function AddField({ handleAdd, title }) {
  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      width={{ xs: "100%", sm: "100%", md: "100%" }}
      boxShadow="0px 2px 10px rgba(50, 50, 50, 0.25)"
      borderRadius={3}
      sx={{ cursor: "pointer", boxSizing: "border-box" }}
      p={2}
      my={2}
      onClick={handleAdd}
    >
      <Typography variant="h2" mr={2}>
        {title}
      </Typography>
      <MdAdd fontSize={22} color="#4C466F" />
    </Box>
  );
}

export default AddField;
